import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        CTI: {
            MyNumbers: [],
            AllInfo: '',
            CustomerData: '',
            UserInfo: '',
            CallInData: '',
            CallOutData: '',
            LineAtData: '',
            CallInID: '',
            CallInCategory: '',
            CallInHistoryToday: '',
            IsInitial: false,
            open: false,
            AudioRecord: '',
            PhoneTimeData: '',
            SideBarTab: 'CustomerInfo',
            pin: true,
            CallOutID: null,
            GlobalToken: '',
            GlobalLocation: '',
            AgentDial: ''
        },
    },
    mutations: {
        GetWhichAgentDial(state, payload) {
            this.state.CTI.AgentDial = payload
        },
        SetGlobalToken(state, payload) {
            this.state.CTI.GlobalToken = payload
        },
        SetGlobalLocation(state, payload) {
            this.state.CTI.GlobalLocation = payload
        },
        CallOutData(state, payload) {
            this.state.CTI.CallOutData = payload
        },
        setCallOutID(state,payload) {
            this.state.CTI.CallOutID = payload
        },
        ChangePin(state, payload) {
            this.state.CTI.pin = payload
        }, 
        ChangeSideBarTab(state, payload) {
            this.state.CTI.SideBarTab = payload
        },
        GetCallInPhoneTime(state, payload) {
            this.state.CTI.PhoneTimeData = payload
        },
        changeStatus(state, payload) {
            this.state.CTI.AllInfo = payload
        },
        changeExt(state, payload) {
            this.state.CTI.MyNumbers = payload
        },
        GetCustomerData(state, payload) {
            this.state.CTI.CustomerData = payload
        },
        GetUserInfo(state, payload) {
            this.state.CTI.UserInfo = payload
        },
        GetCallInData(state, payload) {
            this.state.CTI.CallInData = payload
        },
        GetCustomerLineAtData(state, payload) {
            this.state.CTI.LineAtData = payload
        },
        GetCallInID(state, payload) {
            this.state.CTI.CallInID = payload
        },
        GetCallInCategory(state, payload) {
            this.state.CTI.CallInCategory = payload
        },
        GetCallInHistoryToday(state, payload) {
            this.state.CTI.CallInHistoryToday = payload
        },
        changeInitial(state, payload) {
            this.state.CTI.IsInitial = payload
        },
        changeOpen(state, payload) {
            this.state.CTI.open = payload
        },
        ChangeAudioRecord(state, payload) {
            this.state.CTI.AudioRecord = payload
        }
    },
    actions: {
        handGetWhichAgentDial(context,payload) {
            context.commit("GetWhichAgentDial", payload)
        },
        handSetGlobalToken(context, payload) {
            context.commit("SetGlobalToken", payload)
        },
        handSetGlobalLocation(context, payload) {
            context.commit("SetGlobalLocation", payload)
        },
        handCallOutData(context, payload) {
            context.commit("CallOutData", payload)
        },
        handsetCallOutID(context, payload) {
            context.commit("setCallOutID", payload)
        },
        handChangePin(context, payload) {
            context.commit("ChangePin", payload)
        },
        handChangeSideBarTab(context, payload) {
            context.commit("ChangeSideBarTab", payload)
        },
        handGetCallInPhoneTime(context, payload) {
            context.commit("GetCallInPhoneTime", payload)
        },
        handchangeStatus(context, payload) {
            context.commit("changeStatus", payload)
        },
        handchangeExt(context, payload) {
            context.commit("changeExt", payload)
        },
        handGetCustomerData(context, payload) {
            context.commit("GetCustomerData", payload)
        },
        handGetCallInData(context, payload) {
            context.commit("GetCallInData", payload)
        },
        handGetCustomerLineAtData(context, payload) {
            context.commit("GetCustomerLineAtData", payload)
        },
        handGetCallInID(context, payload) {
            context.commit("GetCallInID", payload)
        },
        handGetCallInCategory(context, payload) {
            context.commit("GetCallInCategory", payload)
        },
        handGetCallInHistoryToday(context, payload) {
            context.commit("GetCallInHistoryToday", payload)
        },
        handchangeInitial(context, payload) {
            context.commit("changeInitial", payload)
        },
        handchangeOpen(context, payload) {
            context.commit("changeOpen", payload)
        },
        handChangeAudioRecord(context, payload) {
            context.commit("ChangeAudioRecord", payload)
        },
        handGetUserInfo(context, payload) {
            context.commit("GetUserInfo", payload)
        },
    },
    getters: {
        CTIMyNumbers(state) {
            return state.CTI.MyNumbers
        },
        CTIAllInfo(state) {
            return state.CTI.AllInfo
        },
        CTICustomerData(state) {
            return state.CTI.CustomerData
        },
        CTIUserInfo(state) {
            return state.CTI.UserInfo
        },
        CTICallInData(state) {
            return state.CTI.CallInData
        },
        CTICallOutData(state) {
            return state.CTI.CallOutData
        },
        CTILineAtData(state) {
            return state.CTI.LineAtData
        },
        CTICallInID(state) {
            return state.CTI.CallInID
        },
        CTICallInCategory(state) {
            return state.CTI.CallInCategory
        },
        CTICallInHistoryToday(state) {
            return state.CTI.CallInHistoryToday
        },
        CTIIsInitial(state) {
            return state.CTI.IsInitial
        },
        CTIopen(state) {
            return state.CTI.open
        },
        CTIAudioRecord(state) {
            return state.CTI.AudioRecord
        },
        CTIPhoneTimeData(state) {
            return state.CTI.PhoneTimeData
        },
        CTISideBarTab(state) {
            return state.CTI.SideBarTab
        },
        CTIpin(state) {
            return state.CTI.pin
        },
        CTICallOutID(state) {
            return state.CTI.CallOutID
        },
        CTIGlobalToken(state) {
            return state.CTI.GlobalToken
        },
        CTIGlobalLocation(state) {
            return state.CTI.GlobalLocation
        },
        CTIAgentDial(state) {
            return state.CTI.AgentDial
        },
    }
});

export default store;
